import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { XlsxService } from '@delon/abc';
import { CommonsService } from '@core/service/commons.service';
import { UploadFile } from 'ng-zorro-antd';

@Component({
  selector: 'excel-input-front',
  template: `
    <nz-modal [(nzVisible)]="visible.visible" [nzTitle]="title" [nzWidth]="'600'" (nzOnCancel)="excekCancel()"
              (nzOnOk)="excelOk()">
      <nz-row nzGutter="12">
        <nz-col nzMd="4" nzSm="24" class="title">{{'shared.excel-input-front.template'|translate}}：</nz-col><nz-col class="node" nzMd="20" nzSm="24"><a href="./assets/template/{{templateName}}">{{'shared.excel-input-front.loadTemplate'|translate}}</a></nz-col>
        <nz-col nzMd="4" nzSm="24" class="title">{{'shared.excel-input-front.load'|translate}}：</nz-col><nz-col class="node" nzMd="20" nzSm="24">
      <nz-upload nzMultiple
                 [(nzFileList)]="fileList"
                 [nzBeforeUpload]="beforeUpload"
                 [nzLimit]="1"
                 [nzRemove]="remove"
      >
    <button nz-button>
      <i class="anticon anticon-upload"></i><span>{{'shared.excel-input-front.chooseFile'|translate}}</span>
    </button>
  </nz-upload>
      </nz-col>
      <nz-col nzMd="4" nzSm="24" class="title">{{'shared.excel-input-front.declare'|translate}}：</nz-col><nz-col class="node" nzMd="20" nzSm="24">{{description}}
      </nz-col>
      </nz-row>
    </nz-modal>`,
  styles: [`
    .title {
      line-height: 40px;
      font-weight: bold;
    }

    .node {
      line-height: 40px;
    }
  `],
})
export class ExcelInputFrontComponent implements OnInit {

  //导入框开关
  @Input() visible={
    "visible":false
  };
  //导入框标题
  @Input() title: string = this.commons.translate('shared.excel-input-front.loadEx');
  //导入说明
  @Input() description: string = this.commons.translate('shared.excel-input-front.noteRules');
  //模板名称
  @Input() templateName: string;
  //将excel解析后的数据绑定至此变量
  @Input() dataModels = [];
  //当改变业务对象时父组件刷新
  @Output() private childOuter = new EventEmitter();

  //文件类型
  private fileType = 'xls,xlsx';
  //文件列表
  fileList: File[] = [];
  //文件大小
  private fileSize = 2 * 1024 * 1024;
  //数据模型
  private dataModel: any = {};
  //导入的Excel数据
  private excelData: any;


  constructor(
    private xlsx: XlsxService,
    private commons: CommonsService,
  ) {
  }

  ngOnInit() {
  }

  //excel导入框 -> cancel
  excekCancel() {
    this.visible.visible = false;
    this.excelData = null;
    this.fileList = [];
    this.childOuter.emit();
  }

  beforeUpload = (file): boolean => {
    let name: string = file.name;
    let suf = name.substring(name.lastIndexOf('.') + 1, name.length);
    if (this.fileType.indexOf(suf) < 0) {
      this.commons.showWarningMessage('shared.excel-input-front.xls');
      return false;
    }
    if (file.size > this.fileSize) {
      this.commons.showWarningMessage('shared.excel-input-front.Mb');
      return false;
    }
    this.xlsx.import(file).then(res => {
      this.excelData = res;
    }).catch(error => {
        this.commons.showErrorMessage('shared.excel-input-front.wrongFile');
      },
    );
    //只能传一个文件
    this.fileList = [];
    this.fileList.push(file);
    return false;
  };

  remove = () => {
    this.fileList = [];
    this.dataModels = [];
  };

  excelOk() {
    for (let k in this.excelData) {
      let excelDatum = this.excelData[k];
      if (excelDatum.length > 3) {
        for (let j = 3; j < excelDatum.length; j++) {
          for (let i = 0; i < excelDatum[0].length; i++) {
            this.dataModel[excelDatum[0][i]] = excelDatum[j][i];
          }
          this.dataModels.push(this.dataModel);
          this.dataModel = {};
        }
      }
    }
    this.fileList = [];
    this.visible.visible = false;
    this.childOuter.emit(this.dataModels);
  }

}
